import React from 'react';

const normCompany = (name) => String(name || '').trim().toLowerCase();

const ProductCategoryDepthChart = ({
  categories = [],
  categoryDetails = [],
  dataByCompany,
  maxVal,
  companyOrder = [],
  subjectCompany = '',
}) => {
  if (!dataByCompany) return null;
  const companies = companyOrder.length ? companyOrder : Object.keys(dataByCompany);
  const subjectKey = normCompany(subjectCompany);

  const rows = categoryDetails.length
    ? categoryDetails
    : categories.map((key) => ({ key, label: key }));

  if (!rows.length) return null;

  return (
    <div className="product-depth-chart">
      {rows.map((catRow, idx) => {
        const catKey = catRow.key || catRow.label;
        const rowHasBars = companies.some((co) => ((dataByCompany[co] && dataByCompany[co][catKey]) || 0) > 0);
        if (!rowHasBars) return null;

        const safeMax = Math.max(Number(maxVal) || 0, 1);
        const categoryLabel = catRow.label || catKey;
        const priorityTone = catRow.priorityTone || null;
        const categoryTitle = catRow.priorityLevel
          ? `${categoryLabel} — ${catRow.priorityLevel} priority`
          : categoryLabel;
        const categoryClassName = [
          'product-depth-row__category',
          priorityTone ? `product-depth-row__category--priority-${priorityTone}` : '',
        ].filter(Boolean).join(' ');

        return (
          <div key={catKey || idx} className="product-depth-row">
            <div className={categoryClassName} title={categoryTitle}>
              {categoryLabel}
            </div>
            <div className="product-depth-row__bars">
              {companies.map((co, cIdx) => {
                const val = (dataByCompany[co] && dataByCompany[co][catKey]) || 0;
                if (val === 0) return null;

                const widthPct = Math.min(100, Math.round((val / safeMax) * 100));
                const isOurs = subjectKey && normCompany(co) === subjectKey;
                const fillClass = isOurs
                  ? 'product-depth-bar-row__fill product-depth-bar-row__fill--ours'
                  : 'product-depth-bar-row__fill product-depth-bar-row__fill--competitor';

                return (
                  <div key={cIdx} className="product-depth-bar-row" title={co}>
                    <div className="product-depth-bar-row__company">{co}</div>
                    <div className="product-depth-bar-row__track">
                      <div
                        className={fillClass}
                        style={{
                          width: `${widthPct}%`,
                          '--chart-bar-delay': `${0.2 + idx * 0.06 + cIdx * 0.04}s`,
                        }}
                      />
                    </div>
                    <span className="product-depth-bar-row__value">{val}</span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductCategoryDepthChart;
